import { loggingException } from 'app/libs/sentry';

export default null;
export const reportExceptionMiddleware = () => (next) => (action) => {
	try {
		return next(action);
	} catch (error) {
		console.error(error);
		loggingException(error);
		throw error;
	}
};
